// extracted by mini-css-extract-plugin
module.exports = {"logo":"mobilelogin2style_logo__4A219","inputLabel":"mobilelogin2style_inputLabel__2Ino0","buttonscontainer":"mobilelogin2style_buttonscontainer__1AanB"};